import { Component, ViewChild, ElementRef, ɵConsole, WritableSignal, signal } from "@angular/core"; import { Location } from "@angular/common";
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { CleValeur, CleValeurNumerique } from '../../entites/cleValeur';
import { EntreeCommande } from '../../entites/entree-commande';
import { ItemMin } from '../../entites/item-min';
import { Statut } from '../../entites/statut';
import { DonneesBaseService } from '../../services/donnees-base-service';
import { BaseComponent } from '../../base/base-component';
import { ItemService } from '../../services/item-service';
import { BlockUIModule } from 'primeng/blockui';
import { FournisseurService } from '../../services/fournisseur-service';
import { Fournisseur } from '../../entites/fournisseur';
import { EmployeEntite } from '../../entites/employe';
import { ItemCommandeEntite } from '../../entites/item-commande';
import { MessageService } from 'primeng/api';
import { Table } from 'primeng/table/table';
import { ProfilService } from '../../services/profil-service';
import { ActivatedRoute, Router } from '@angular/router';
import { RequisitionService } from '../../services/requisition-service';
import { AppMainComponent } from '../../app.main.component';
import { CategorieEntite } from '../../entites/categorie';
import { EStatutsSpeciaux } from '../../entites/enums/statuts-speciaux';
import { HttpEvent, HttpEventType } from "@angular/common/http";

@Component({
    selector: 'app-selection-multiple-unite-mecanique',
    templateUrl: './selection-multiple-unite-mecanique.component.html'
})
export class SelectionMutipleUniteMecaniqueComponent extends BaseComponent {

    submitted: boolean;

    items: ItemMin[];
    selectionItems: ItemMin[] = [];

    loadingEvent: WritableSignal<HttpEvent<any>> = signal(null);
    loadingError: WritableSignal<string> = signal(null);

    @ViewChild('rechercheItem') inputRechercheItem;
    @ViewChild('dt') tableItems: Table;

    constructor(
        profilService: ProfilService,
        route: ActivatedRoute, 
        routerService: Router,
		appMain: AppMainComponent, location: Location, 
        public itemService: ItemService,
        public requisitionService: RequisitionService,
        public fournisseurService: FournisseurService,
        public messageService: MessageService,
        public ref: DynamicDialogRef,
        public config: DynamicDialogConfig,
        public sdb: DonneesBaseService) {
        super(sdb, profilService, route, routerService, appMain);
    }



    ngOnInit() {

        this.colonnesDisponibles = [
            { champ: 'categorie', entete: 'Catégorie', afficheParDefaut: true },
            { champ: 'sousCategorie', entete: 'Sous-catégorie', afficheParDefaut: true },
            { champ: 'marque', entete: 'Marque', afficheParDefaut: true },
            { champ: 'modele', entete: 'Modèle', afficheParDefaut: true }
        ];

        this.colonnesSelectionnees = this.colonnesDisponibles.filter(x => x.afficheParDefaut);

        this.itemService.ObtenirItems(EStatutsSpeciaux.UnitesMecanique).subscribe({
            next: (x) => {
                if (x.type == HttpEventType.Response) {
                    this.items = x.body.value();

                    this.CompleterChargement();

                    setTimeout(() => { this.inputRechercheItem.nativeElement.focus(); }, 100);
                }
                this.loadingEvent.set(x);
            },
            error: (error) => {
                this.loadingError.set(error.error);
            }

        });

    }
   
    surEntreeRecherche() {

        if (this.tableItems.filteredValue != undefined &&
            this.tableItems.filteredValue.length == 1) {

            this.selectionItems = [this.tableItems.filteredValue[0]];
            this.confirmer();
        }

    }

    annuler() {
        this.ref.close(null);
    }

    confirmer() {

        this.ref.close(this.selectionItems);

    }
}